var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPartnersCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05687 8.57188L5.52827 12.1005C5.26792 12.3608 5.26792 12.7829 5.52827 13.0433C5.78862 13.3036 6.21073 13.3036 6.47108 13.0433L10.4711 9.04328C10.7314 8.78293 10.7314 8.36082 10.4711 8.10047L6.47108 4.10047C6.21073 3.84013 5.78862 3.84013 5.52827 4.10047C5.26792 4.36082 5.26792 4.78293 5.52827 5.04328L9.05687 8.57188Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPartnersCards);
export default __webpack_public_path__ + "static/media/arrowPartnersCards.3693f4f9803724a213c5ef529cdf1730.svg";
export { ForwardRef as ReactComponent };